import PropTypes from 'prop-types';

/**
 * Reusable error message component with consistent styling.
 *
 * @param {Object} props
 * @param {string} props.message - Error message to display
 */
function ErrorMessage({ message }) {
  if (!message) return null;

  return (
    <div className="p-3 bg-puzzle-danger/10 border border-puzzle-danger/30 rounded-lg">
      <p className="text-puzzle-danger text-sm">{message}</p>
    </div>
  );
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

ErrorMessage.defaultProps = {
  message: '',
};

export default ErrorMessage;
